import React from 'react';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

interface IRsvpStatCardProps {
  label: string;
  // Optional: caller passes `undefined` when the values can't be displayed
  // (missing data, invariant violation — see `validateAttendanceRatio`).
  // The card renders an em-dash for both the ratio and the percent in that
  // case, keeping the card shape stable.
  numerator?: number;
  denominator?: number;
}

export const RsvpStatCard: React.FC<IRsvpStatCardProps> = ({ label, numerator, denominator }) => {
  const isValid = typeof numerator === 'number' && typeof denominator === 'number';
  // Guard against divide-by-zero: a player with no RSVP-requested sessions
  // shouldn't show "NaN%" — we render a literal em-dash instead.
  const percent = isValid && denominator! > 0 ? Math.round((numerator! / denominator!) * 100) : null;
  const ratioDisplay = isValid ? `${numerator} / ${denominator}` : '—';

  return (
    <Paper
      elevation={1}
      style={{
        padding: '1rem 1.25rem',
        textAlign: 'center',
        minWidth: '160px',
      }}
    >
      <Typography variant="overline" color="textSecondary" style={{ display: 'block', lineHeight: 1.2 }}>
        {label}
      </Typography>
      <Typography variant="h4" style={{ marginTop: '0.25rem', fontWeight: 600 }}>
        {ratioDisplay}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        {percent === null ? '—' : `${percent}%`}
      </Typography>
    </Paper>
  );
};

